module.exports = __webpack_public_path__ + "static/media/why4.6d3e3095.png";